import React from 'react'
import Helmet from 'react-helmet'

const SEO = props => {
  // console.log('location:', props)
  // console.log('process:', process)
  let title
  let description
  let image
  title = process.env.siteTitle
  description = process.env.siteDescription
  image = process.env.siteBanner
  image = `${process.env.siteUrl}${process.env.pathPrefix}${image}`
  const blogURL = `${process.env.siteUrl}${process.env.pathPrefix}`

  const schemaOrgJSONLD = [
    {
      '@context': 'http://schema.org',
      '@type': 'WebSite',
      url: blogURL,
      name: title,
      alternateName: process.env.siteTitleAlt ? process.env.siteTitleAlt : ''
    }
  ]
  return (
    <Helmet>
      <title>
        {props.slug} | {process.env.siteTitle}
      </title>
      <meta name="description" content={description} />
      <meta name="keywords" content={process.env.siteKeywords} />
      <meta name="image" content={image} />
      <script type="application/ld+json">{JSON.stringify(schemaOrgJSONLD)}</script>
      <meta property="og:locale" content="de_DE" />
      <meta property="og:site_name" content={process.env.ogSiteName} />
      <meta property="og:url" content={blogURL} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="fb:app_id" content={process.env.siteFBAppID ? process.env.siteFBAppID : ''} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:creator" content={process.env.userTwitter ? process.env.userTwitter : ''} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:url" content={process.env.siteUrl} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
    </Helmet>
  )
}

export default SEO



// WEBPACK FOOTER //
// ./src/components/SEO/index.js